import { render, staticRenderFns } from "./ConfirmNewPass.vue?vue&type=template&id=d69c231c"
import script from "./ConfirmNewPass.vue?vue&type=script&lang=js"
export * from "./ConfirmNewPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports